export default "__VITE_ASSET__BKcV9toe__"